module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACBSURBVHgB7Y+xDYAgEEXvYAAdgRG0ZSoaQu0AJIziBpSUxg10AwYgRChI1MQErSx4yeWKl/v5B9D4jBCif3IUKpBSDohoOefeObfePUIlqQkjhNg0cwhhMsb44khtSDraYoxjGqCULkopdmmS/80C6mFla613PNXNQR28IAdA4+ccDeMlkOvN/B4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/go.png
// module id = ibnJ
// module chunks = 1